<template>
  <v-dialog v-model="shown" max-width="500">
    <v-card class="pb-1">
      <v-card-title class="headline">
        {{ $t('common.attention') }}
      </v-card-title>

      <v-card-text>
        <span class="body-2 blue-grey--text text--darken-3" v-html="message" />
      </v-card-text>

      <v-card-actions>
        <v-spacer />

        <v-btn plain @click="cancel">{{ $t('common.button.cancel') }}</v-btn>

        <v-btn color="primary" plain @click="confirm">{{
          $t('common.button.continue')
        }}</v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
export default {
  name: 'GrantAccessToAllUsersConfirmation',

  props: {
    shown: {
      type: Boolean,
      required: true,
    },
    newAccessValue: {
      type: Boolean,
      required: false,
    },
  },

  computed: {
    message() {
      return !this.newAccessValue
        ? this.$t(
            'ai_features.user_access_control.grant_ai_access_to_all_users_confirmation'
          )
        : this.$t(
            'ai_features.user_access_control.revoke_ai_access_to_all_users_confirmation'
          )
    },
  },

  methods: {
    confirm() {
      this.$emit('confirm', !this.newAccessValue)
    },

    cancel() {
      this.$emit('cancel')
    },
  },
}
</script>

<style scoped>
.v-card-text {
  font-size: 16px;
}
</style>
